// extracted by mini-css-extract-plugin
export default {"myNavbar":"navbar_myNavbar__mGSOV","icon":"navbar_icon__2gJsL"};